import { StyledHeader } from "./styles";

interface IHeaderProps {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

const HeaderDesktop = ({ page, setPage }: IHeaderProps) => {
  return (
    <StyledHeader>
      <div className="container">
        <nav>
          {page !== 0 && <button onClick={() => setPage(0)}>Home</button>}
          <button onClick={() => setPage(1)}>Projects</button>
          <button onClick={() => setPage(2)}>About me</button>
          <button onClick={() => setPage(3)}>Contact</button>
        </nav>
      </div>
    </StyledHeader>
  );
};

export default HeaderDesktop;
